'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const ErrorIcon = createIcon({
    displayName: 'ErrorIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M8 5.933V8.6m0 2.666h.007m6.66-2.666a6.667 6.667 0 11-13.333 0 6.667 6.667 0 0113.333 0z"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default ErrorIcon
